module.exports = __webpack_public_path__ + "static/media/bg_result.eff884c9.png";